import request from '@/utils/request';

export function getHome() {
    return request({
        url: `/mavin/home`,
        method: 'get'
    });
}

export function countHome() {
    return request({
        url: `/home/count/me`,
        method: 'get'
    });
}